import React, { useRef, useEffect } from 'react';

import { Route, Redirect } from 'react-router-dom';

export const AuthRoute = ({ isAuth, component: Component, ...routeProps }) => {
  const prevAuth = useRef(isAuth);

  useEffect(() => {
    prevAuth.current = isAuth;
  }, [isAuth]);

  const renderComponent = (props) =>
    isAuth ? (
      <Component {...props} routeProps={routeProps} />
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: prevAuth.current ? null : props.location }
        }}
      />
    );

  return <Route {...routeProps} render={renderComponent} />;
};

export default AuthRoute;
